if (!process.env.REACT_APP_INTERVIEW_MAX_TRAININGS)
  throw new Error('Missing REACT_APP_INTERVIEW_MAX_TRAININGS environment variable');

const MAX_TRAININGS = Number(process.env.REACT_APP_INTERVIEW_MAX_TRAININGS);
if (!Number.isFinite(MAX_TRAININGS))
  throw new Error('REACT_APP_INTERVIEW_MAX_TRAININGS environment variable is not a valid number');

export { MAX_TRAININGS };
